import { h } from 'preact'

import { ContentType } from '@insided/shared/utils/contentType'
/* eslint-disable import/no-internal-modules */
import CreateZendeskTicketButton from './Zendesk/CreateZendeskTicketButton'
import CreateProductNoteButton from './ProductBoard/CreateProductNoteButton'
import CreateSalesforceCaseButton from './Salesforce/CreateSalesforceCaseButton'
import CreateFreshdeskTicketButton from './Freshdesk/CreateFreshdeskTicketButton'

interface Props {
  isProductboardNoteCreationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  trashed: boolean
  title?: string
  username?: string
  userId: string
  content?: string | null
  publicId: number
  moderatorId: string
  isReply: boolean
  contentType: ContentType
  destinationUrl: string
  topicId: number
}

const EscalationOptions = ({ isZendeskTicketEscalationEnabled, isSalesforceCaseEscalationEnabled, isProductboardNoteCreationEnabled, isFreshdeskTicketEscalationEnabled, trashed, userId, username, publicId, moderatorId, title, content, contentType, isReply, destinationUrl, topicId }: Props) => {
  return (
    <div className='escalation-options'>
      {isFreshdeskTicketEscalationEnabled && <CreateFreshdeskTicketButton
        isEnabled={isFreshdeskTicketEscalationEnabled && !trashed}
        userId={userId}
        username={username}
        publicId={publicId}
        moderatorId={moderatorId}
        title={title}
        content={content}
        isReply={isReply}
        contentType={contentType}
        isTrashed={trashed}
        destinationUrl={destinationUrl}
        topicId={topicId}
                                             />}
      {isZendeskTicketEscalationEnabled && <CreateZendeskTicketButton
        isEnabled={isZendeskTicketEscalationEnabled && !trashed}
        userId={userId}
        username={username}
        publicId={publicId}
        moderatorId={moderatorId}
        title={title}
        content={content}
        isReply={isReply}
        contentType={contentType}
        isTrashed={trashed}
        destinationUrl={destinationUrl}
        topicId={topicId}
                                           />}
      {isProductboardNoteCreationEnabled && <CreateProductNoteButton
        isEnabled={isProductboardNoteCreationEnabled && !trashed}
        userId={userId}
        username={username}
        publicId={publicId}
        moderatorId={moderatorId}
        title={title}
        content={content}
        isReply={isReply}
        contentType={contentType}
        isTrashed={trashed}
                                            />}
      {isSalesforceCaseEscalationEnabled && <CreateSalesforceCaseButton
        isEnabled={isSalesforceCaseEscalationEnabled && !trashed}
        userId={userId}
        username={username}
        publicId={publicId}
        moderatorId={moderatorId}
        title={title}
        content={content}
        isReply={isReply}
        contentType={contentType}
        isTrashed={trashed}
        destinationUrl={destinationUrl}
        topicId={topicId}
                                            />}
    </div>

  )
}

export default EscalationOptions
